// extracted by mini-css-extract-plugin
export default {"ctn":"Specs_ctn_obY5x","list":"Specs_list_uMOHX","li":"Specs_li_I0yfe","icon":"Specs_icon_ngCfq","text":"Specs_text_hhi3R"};